
import React, { Component } from 'react';
import { bool, func, string } from 'prop-types';
import { css } from 'aphrodite';
import Switch from 'react-toggle-switch';

import styles from './styles.js';

class AdminSwitch extends Component {
    static propTypes = {
        className: string,
        handleClick: func.isRequired,
        isChecked: bool.isRequired,
        switchLabel: string.isRequired
    }

    handleClick = () => {
        const { handleClick } = this.props;
        handleClick();
    }

    render() {
        const { handleClick } = this;
        const { className, isChecked, switchLabel } = this.props;
        return (
            <div className={css(styles.inlineSwitch)}>
                <label className={css(styles.switchLabel)}>
                    {switchLabel}
                </label>
                <Switch
                    className={className}
                    onClick={handleClick}
                    on={Boolean(isChecked)}
                />
            </div>
        );
    }
}

export default AdminSwitch;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/CardSlider/CardContainer/Card/AdminControls/AdminSwitch/AdminSwitch.jsx